module.exports = __webpack_public_path__ + "static/img/img_4.1e07e3dd.jpg";